<template>
  <div class="student-task-list-page">
    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
      <div slot="header" class="row align-items-center">
        <div class="col-lg-6">
          <h6 class="text-uppercase ls-1 mb-1">Monitoring Modul</h6>
        </div>
        <div class="col-lg-6 text-lg-right"></div>
      </div>
      <div class="text-center text-muted">
        <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
          <div class="p-2">
            <b-row>
              <b-col lg="1" class="my-1">
                <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"></b-form-select>
              </b-col>
              <b-col lg="8" class="my-1"> </b-col>
              <b-col lg="3" class="my-1">
                <b-input-group size="sm">
                  <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Cari"></b-form-input>
                  <b-input-group-append>
                    <!-- <b-button variant="primary" style="border-radius: 0px !important" class="btn btn-primary" @click="getUserModulMonitoringList()">Reload</b-button> -->
                    <b-button variant="primary" style="border-radius: 0px !important" class="btn btn-info" @click="downloadExcel(filter_form)">Download Excel</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <!-- <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.taId" name="taId" v-validate="'required'" value-field="id" placeholder="Nama Tahun Ajaran" text-field="name" data-vv-as="Nama Tahun Ajaran" :options="taList">
                    <b-form-select-option :value="null" disabled>Pilih Tahun Ajaran</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="1" class="my-1">
                <b-input-group size="sm">
                  <b-form-select
                    v-model="filter_form.classId"
                    name="classId"
                    v-validate="'required'"
                    value-field="id"
                    placeholder="Nama Kelas"
                    text-field="name"
                    data-vv-as="Nama Kelas"
                    :options="classList"
                    @change="getSubjectListFilter(filter_form)"
                  >
                    <b-form-select-option :value="null" disabled>Pilih Kelas</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="1" class="my-1">
                <b-input-group size="sm">
                  <b-form-select
                    v-model="filter_form.semester"
                    name="semester"
                    v-validate="'required'"
                    value-field="id"
                    placeholder="Semester"
                    text-field="name"
                    data-vv-as="Semester"
                    :options="semesterList"
                    @change="getSubjectListFilter(filter_form)"
                  >
                    <b-form-select-option :value="null" disabled>Semester</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select
                    v-model="filter_form.subjectId"
                    name="subjectId"
                    v-validate="'required'"
                    value-field="id"
                    placeholder="Nama Mapel"
                    text-field="name"
                    data-vv-as="Nama Mapel"
                    :options="subjectList"
                    @change="getLaListFilter(filter_form)"
                  >
                    <b-form-select-option :value="null" disabled>Pilih Mapel</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.laId" name="laId" v-validate="'required'" value-field="id" placeholder="Nama Modul" text-field="name" data-vv-as="Nama Modul" :options="laList" @change="getModulListFilter(filter_form)">
                    <b-form-select-option :value="null" disabled>Pilih Modul</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="3" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.modulId" name="modulId" v-validate="'required'" value-field="id" placeholder="Nama Sub Modul" text-field="name" data-vv-as="Nama Sub Modul" :options="modulList">
                    <b-form-select-option :value="null" disabled>Pilih Sub Modul</b-form-select-option>
                  </b-form-select>
                  <b-input-group-append>
                    <b-button
                      variant="primary"
                      :disabled="!filter_form.taId || !filter_form.classId || !filter_form.subjectId || !filter_form.laId || !filter_form.modulId"
                      style="border-radius: 0px !important"
                      class="btn btn-primary"
                      @click="getUserModulMonitoringList(filter_form)"
                      >Filter</b-button
                    >
                    <b-button
                      variant="primary"
                      :disabled="!filter_form.taId || !filter_form.classId || !filter_form.subjectId || !filter_form.laId || !filter_form.modulId"
                      style="border-radius: 0px !important"
                      class="btn btn-info"
                      @click="downloadExcel(filter_form)"
                      >Excel</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-col> -->
            </b-row>
            <b-table
              :items="userModulMonitoringList"
              :fields="fields"
              :busy="isBusy"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              responsive
              show-empty
              small
              @filtered="onFiltered"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo" /><br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(image_path)="row">
                <div class="media d-flex justify-content-center">
                  <a href="javascript:void(0)" class="avatar rounded-circle">
                    <img alt="" height="50px" :src="row.item.image_path" />
                  </a>
                </div>
              </template>
              <template #cell(full_name)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.full_name }}</label>
                </div>
              </template>
              <template #cell(email)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.email }}</label>
                </div>
              </template>
              <template #cell(kelas)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.kelas }}</label>
                </div>
              </template>
              <template #cell(mapel)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.mapel }}</label>
                </div>
              </template>
              <template #cell(nama_modul)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.nama_modul }}</label>
                </div>
              </template>
              <template #cell(sub_modul)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.sub_modul }}</label>
                </div>
              </template>
              <template #cell(waktu)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.waktu }}</label>
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-lg-end justify-content-center py-2">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "../../../axiosHelper";
export default {
  props: {
    type: {
      type: String,
      default: null,
    },
    semesterList: {
      type: Array,
      default() {
        return [
          {
            id: "1",
            name: "Ganjil",
          },
          {
            id: "2",
            name: "Genap",
          },
        ];
      },
    },
  },
  components: {
    // SquareLoader
  },
  data() {
    return {
      isBusy: false,
      showLoader: false,
      items: [],
      fields: [
        { key: "image_path", label: "Foto", sortable: false, class: "foto-field" },
        { key: "nama_siswa", label: "Nama Lengkap", sortable: true, sortDirection: "desc", class: "text-left" },
        { key: "email", label: "Email", sortable: false, class: "text-left" },
        { key: "kelas", label: "Kelas", sortable: false, class: "text-center" },
        { key: "mapel", label: "Mata Pelajaran", sortable: false, class: "text-left" },
        { key: "nama_modul", label: "Modul", sortable: false, class: "text-left" },
        { key: "sub_modul", label: "Sub Modul", sortable: false, class: "text-left" },
        { key: "waktu", label: "Waktu", sortable: false, class: "text-left" },
      ],
      filter_form: {
        taId: null,
        classId: null,
        subjectId: null,
        laId: null,
        modulId: null,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 200, 400, 800, 1000],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapGetters({
      taList: "getTaList",
      classList: "getClassList",
      subjectList: "getSubjectListFilter",
      laList: "getLaListFilter",
      modulList: "getModulListFilter",
      userModulMonitoringList: "getUserModulMonitoringList",
      token: "getToken",
    }),
  },
  methods: {
    downloadExcel(param) {
      let token = this.token;
      let taId = param.taId;
      let classId = param.classId;
      let subjectId = param.subjectId;
      let laId = param.laId;
      let modulId = param.modulId;
      let route = axios.defaults.baseURL + "/v2/user-material-monitoring/download/" + taId + "/" + classId + "/" + subjectId + "/" + laId + "/" + modulId + "?token=" + token;
      window.open(route);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getUserModulMonitoring(form) {
      this.getUserModulMonitoringList(form);
    },
    // async getUserModulMonitoringList(form) {
    async getUserModulMonitoringList() {
      this.isBusy = true;
      // let taId = form.taId;
      // let classId = form.classId;
      // let subjectId = form.subjectId;
      // let laId = form.laId;
      // let modulId = form.modulId;
      let taId = 0;
      let classId = 0;
      let subjectId = 0;
      let laId = 0;
      let modulId = 0;
      await this.$store
        .dispatch("getUserModulMonitoringList", { taId, classId, subjectId, laId, modulId })
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getTaList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getTaList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getClassList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getClassList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getSubjectListFilter(param) {
      this.isBusy = true;
      let classId = param.classId;
      let semester = param.semester;
      await this.$store
        .dispatch("getSubjectListFilter", { classId, semester })
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getLaListFilter(param) {
      this.isBusy = true;
      let subjectId = param.subjectId;
      await this.$store
        .dispatch("getLaListFilter", { subjectId })
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getModulListFilter(param) {
      this.isBusy = true;
      let laId = param.laId;
      await this.$store
        .dispatch("getModulListFilter", { laId })
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
  },
  destroyed() {
    let resp = null;
    this.$store.commit("setUserModulMonitoringList", { resp });
  },
  mounted() {
    this.totalRows = this.userModulMonitoringList.length;
  },
  async created() {
    await this.getTaList();
    await this.getClassList();
    await this.getUserModulMonitoringList();
  },
};
</script>
<style lang="css" scoped>
.foto-field {
  height: 50px;
}
.line-with-icon svg {
  /* color: #adb7be; */
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1rem;
}
.line-with-icon {
  position: relative;
  padding: 0 0 0 1.75em;
  margin: 0 0 1em;
}
.user-article a {
  color: black;
}
.class-list > .line-with-icon > a {
  color: #ca062a;
}
.user-article a:hover {
  color: #ca062a;
}

.btn-open-answer {
  color: #6c757d;
}
.btn-open-answer:hover {
  color: #ca062a;
}
</style>
